import { render } from "./layoutHeader.vue?vue&type=template&id=40bc995a&scoped=true"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"

import "./layoutHeader.vue?vue&type=style&index=0&id=40bc995a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bc995a"]])

export default __exports__